
import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Button, IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import SnackBarCustom from './snackbar'
import { useLocation } from "react-router-dom";
import HeaderSortable from '../common/header-sortable';
import { useTranslate, useDataProvider } from 'react-admin';
import SnackBar from '../common/snackbar';
import ConfirmDialogRole from '../CustomizedUIs/ConfirmDialogRole';
import icDelete from '../assets/icons/primary-blue-bin.png'

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit'
    },
    body: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        color: theme.palette.common.white,
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },

    },
    Nodata: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
        padding: '30px'
    },
    TextRole: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
    }, TextBtn: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    TextRole: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        paddingLeft: '30px'
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    }
}));


const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Role name' },
    { id: '', numeric: false, disablePadding: false, label: '' },

];

function EnhancedTableHead(props) {
    const { classes, order, setOrder } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        style={{ paddingLeft: 46 }}
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}

                    >
                        {
                            headCell.label !== "" ?
                                <HeaderSortable
                                    title={headCell.label}
                                    field={headCell.id}
                                    order={order}
                                    setOrder={setOrder}
                                /> : <Box />
                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function RoleTable({ buttonHidden, data, getRoleList, total, roleUser }) {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [order, setOrder] = useState({ field: 'createdAt', order: 'DESC' });
    const [showingSnackbar, setShowingSnackbar] = useState(false);
    const translate = useTranslate()
    const dataProvider = useDataProvider()

    const [open, setOpen] = React.useState(false);
    const location = useLocation();
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [roleIdDelete, setRoleIdDelete] = useState();
    const [showingSnackbarDeleted, setShowingSnackbarDeleted] = useState(false);
    const [boldTextRole, setBoldTextRole] = useState("");
    const [newAssignRoleId, setNewAssignRoleId] = useState();
    const [roleName, setRoleName] = useState(null);

    const handleDelete = () => {
        var requests = []
        requests.push(
            // Update user role
            dataProvider('UPDATE', 'roles/updateuserrole', {
                id: roleIdDelete.id,
                data: {
                    id: newAssignRoleId
                }
            }).then(({ data }) => {
                console.log('data', data)
            }).catch(error => {
                console.log('error', error)
            }),
            // Delete role
            dataProvider('DELETE', "roles", {
                id: roleIdDelete.id
            }).then((response) => {
                var indexDeleted = 0
                data.map((item, index) => {
                    if (item.id === response.data.id)
                        indexDeleted = index
                })
                data.splice(indexDeleted, 1)
                setBoldTextRole(response.data.name)
                // setShowingSnackbarDeleted(true)
                // setOpenConfirmDialog(false)
            }).catch(error => {
                setOpenConfirmDialog(false)
                console.log('error', error)
            }))
        Promise.all(requests)
            .then(() => {
                setShowingSnackbarDeleted(true)
                setOpenConfirmDialog(false)
            })
            .catch((error) => {
                console.log('error', error)
            })
    }

    const handleChangePage = (event, newPage) => {
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getRoleList(order, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
        const pagination = { page: 1, perPage: event.target.value };
        getRoleList(order, pagination);
    };

    const handleRequestSort = (nextSort) => {
        setPage(0);
        setOrder(nextSort);

        const pagination = { page: 1, perPage: rowsPerPage };
        getRoleList(nextSort, pagination);
    };

    const handleClose = () => {

        setOpen(!open);
    };

    useEffect(() => {
        if (location.state && location.state.open === 'true') {
            setShowingSnackbar(true);
            setTimeout(() => {
                setShowingSnackbar(false);
            }, 6000);
        }
    }, []);

    useEffect(() => {
        if (showingSnackbarDeleted === true) {
            setTimeout(() => {
                setShowingSnackbarDeleted(false);
            }, 6000);
        }
    }, [showingSnackbarDeleted]);

    const hasLocationStateName = () => {
        return location.state && location.state.name;
    }

    return (
        <Fragment>
            <SnackBar
                show={showingSnackbar}
                boldText={location.state && location.state.name}
                message={hasLocationStateName() ? translate('resources.role.messageRole') : translate('resources.role.success')}
                onClose={() => setShowingSnackbar(false)}
            />
            {
                showingSnackbarDeleted &&
                <SnackBar
                    show={showingSnackbarDeleted}
                    boldText={boldTextRole}
                    message={translate('resources.role.deleted')}
                    onClose={() => setShowingSnackbarDeleted(false)}
                />
            }
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table aria-label="sticky table">
                        <EnhancedTableHead classes={classes} order={order} setOrder={handleRequestSort} />
                        <TableBody>
                            {
                                data === undefined ?
                                    <Box width="100%">
                                        <Typography align='center' className={classes.Nodata}>{translate('resources.role.nodata')}</Typography>
                                    </Box>
                                    :
                                    data.map((item, index) => (
                                        <TableRow key={'table-row-' + index} hover tabIndex={-1}>
                                            <TableCell key={index + '-0'} className={classes.tableCell}>
                                                <Typography className={classes.TextRole}>{item.name}</Typography>
                                            </TableCell>
                                            <TableCell key={index + '-1'} className={classes.tableCell}>
                                                {
                                                    (!buttonHidden && roleUser !== item.name && item.name !== "Sysadmin") && (
                                                        <Box mr={5} display='flex' justifyContent='flex-end'>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                size='small'
                                                                component={Link}
                                                                to={{
                                                                    pathname: "/roles/" + item.id
                                                                }}
                                                            >
                                                                <Typography className={classes.TextBtn} style={{ padding: '8px' }}>{translate('resources.role.edit')} </Typography>
                                                            </Button>
                                                            {
                                                                <IconButton
                                                                    disabled={item.id < 9}
                                                                    style={{ marginLeft: '1em', padding: '10px', visibility: item.id < 9 ? "hidden" : "visible" }}
                                                                    className={classes.borderDelete}
                                                                    size='small'
                                                                    onClick={() => {
                                                                        setOpenConfirmDialog(true)
                                                                        setRoleIdDelete(item)
                                                                    }}
                                                                >
                                                                    <img src={icDelete} width={15} height={15} />
                                                                </IconButton>
                                                            }
                                                        </Box>
                                                    )
                                                }

                                            </TableCell>
                                        </TableRow>
                                    ))
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
            <ConfirmDialogRole
                open={openConfirmDialog}
                handleClose={() => {
                    setOpenConfirmDialog(false)
                    setRoleName(null)
                }}
                handleConfirm={handleDelete}
                contentText={translate(`resources.role.confirmDelete`)}
                tittle={translate(`resources.role.delete`)}
                value={roleIdDelete}
                setNewAssignRoleId={setNewAssignRoleId}
                roleName={roleName}
                setRoleName={setRoleName}
            />
        </Fragment>
    );
}

export default RoleTable;
